// Minimal bundle for the landing/marketing pages
import { Application } from "@hotwired/stimulus"

import LandingController from "./controllers/landing_controller"
import AccordionController from "./controllers/accordion_controller"
import CookieConsentController from "./controllers/cookie_consent_controller"

const application = Application.start()
application.debug = false
window.Stimulus = application

application.register("landing", LandingController)
application.register("accordion", AccordionController)
application.register("cookie-consent", CookieConsentController)

// --- Google Analytics ---
const gtagId = document.querySelector('meta[name="gtag-id"]')?.content

function initGtag() {
  if (!gtagId || cookieConsent() !== "accepted") return
  if (window.__gtagLoaded) return
  window.__gtagLoaded = true

  const script = document.createElement("script")
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`
  document.head.appendChild(script)

  window.dataLayer = window.dataLayer || []
  window.gtag = function() { window.dataLayer.push(arguments) }
  window.gtag("js", new Date())
  window.gtag("config", gtagId)

  window.gtag("event", "page_view", { page_location: window.location.href })
}

// --- PostHog ---
const apiKey = document.querySelector('meta[name="posthog-key"]')?.content
const userId = document.querySelector('meta[name="posthog-user-id"]')?.content
const userEmail = document.querySelector('meta[name="posthog-user-email"]')?.content
const userPlan = document.querySelector('meta[name="posthog-user-plan"]')?.content
const accountId = document.querySelector('meta[name="posthog-account-id"]')?.content

const AI_REFERRER_DOMAINS = [
  'perplexity.ai', 'chat.openai.com', 'chatgpt.com',
  'you.com', 'phind.com', 'copilot.microsoft.com', 'gemini.google.com'
]
let aiReferrerDomain = null
try {
  if (document.referrer) {
    const referrerHost = new URL(document.referrer).hostname
    if (AI_REFERRER_DOMAINS.some(d => referrerHost === d || referrerHost.endsWith('.' + d))) {
      aiReferrerDomain = referrerHost
    }
  }
} catch (_) {}

function cookieConsent() {
  return document.cookie.split("; ").find(c => c.startsWith("cookie_consent="))?.split("=")[1]
}

function initPostHog() {
  if (!apiKey || cookieConsent() !== "accepted") return
  if (window._posthogInitialized) return
  window._posthogInitialized = true

  const script = document.createElement("script")
  script.src = "https://us-assets.i.posthog.com/static/array.js"
  script.async = true
  script.onload = () => {
    window.posthog.init(apiKey, {
      api_host: "https://us.i.posthog.com",
      autocapture: true,
      capture_pageview: false,
      persistence: "localStorage+cookie",
    })

    if (userId) {
      window.posthog.identify(userId, {
        email: userEmail,
        plan: userPlan,
        account_id: accountId,
      })
    }

    if (aiReferrerDomain) {
      window.posthog.capture('ai_referral_session', { referrer_domain: aiReferrerDomain })
      window.posthog.people.set({ last_ai_referral_source: aiReferrerDomain })
    }

    window.posthog.capture("$pageview", { url: window.location.href })
  }
  document.head.appendChild(script)
}

initPostHog()
initGtag()

document.addEventListener("cookie-consent:accepted", () => {
  initPostHog()
  initGtag()
})
